export enum MovementTypeEnum {
  LOAD = 'Carico',
  TRANSFER = 'Trasferimento',
  ADJUSTMENT = 'Rettifica inventariale',
  RETURN = 'Rientro',
}
